<div *ngIf="this.loaderService.loading$ | async">
<ngx-loading
      [show]="true"
      [config]="{
        animationType: ngxLoadingAnimationTypes.chasingDots,
        primaryColour: primaryColour,
        secondaryColour: secondaryColour,
        backdropBorderRadius: '3px'
      }"
      [template]="loadingTemplate"
    ></ngx-loading>
  </div>
